import React from "react";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../../../layout/BreadCrumb";
import GeneralTable from "./GeneralTable";
import {
  setRefetch,
  setRefetchKey,
  setVerifiedActive,
} from "../../../features/global/globalSlice";
import { Tabs } from "antd";

function VerifiedList() {
  const dispatch = useDispatch();
  //   const [active, setactive] = useState("1");
  const { verfiedActive } = useSelector((state) => state.global);

  async function refetching(verfiedActive) { 
    await dispatch(setVerifiedActive(verfiedActive));
    await dispatch(setRefetch());
    await dispatch(setRefetchKey(verfiedActive));
  }

  const tabConfigurations = [
    {
        label: (
          <span className="flex items-center">
            <span className=" ">All</span>
          </span>
        ),
        key: "1",
        children: <GeneralTable status={null} tabKey="1" />,
      },
   
    {
        label: (
          <span className="flex items-center">
            <span className=" ">Accepted</span>
          </span>
        ),
        key: "3",
        children: <GeneralTable status="ACCEPTED" tabKey="3"/>,
      },
      {
        label: (
          <span className="flex items-center">
            <span className=" ">Installed</span>
          </span>
        ),
        key: "4",
        children: <GeneralTable status="INSTALLED" tabKey="4"/>,
      },

      {
        label: (
          <span className="flex items-center">
            <span className=" ">Verified</span>
          </span>
        ),
        key: "5",
        children: <GeneralTable status="VERIFIED" tabKey="5"/>,
      },
  ];
  return (
    <div >
      <BreadCrumb
        breadcrumbs={[
          { title: "Farmers Overview", path: "/overview-flid" },
          { title: "Standardised EoI" },
        ]}
      />

      <div className="white_card  mt-[2.06rem] flex-1 min-h-[70vh]">
        <div className="form-add-h">Verified Installed Interests</div>
        <Tabs
          items={tabConfigurations}
          defaultActiveKey="1"
          activeKey={verfiedActive}
          onChange={refetching}
          className="mt-[1.75rem] verifed-tab-wrap verifed-tab verifed-bar "
        />
      </div>
    </div>
  );
}

export default VerifiedList;
